import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { api } from "./pureFunctions";
import { Button } from "react-bootstrap";
import { header } from "./globalVariables";
import { saveData, saveEstateData } from "./networkFunctions";

const tableNames = ["estates", "users_audit", "users", "kacheln", "projektstufen"];
const tableIds = {
   estates: "estateId",
   users_audit: "username",
   users: "userId",
   kacheln: "kachelId",
   projektstufen: "stufenId",
};

export default function Logs() {
   const [tableName, setTableName] = useState(tableNames[0]);
   const [limit, setLimit] = useState(20);
   const [logData, setLogData] = useState([]);

   // NEU: State für das Modal
   const [showModal, setShowModal] = useState(false);
   const [selectedCell, setSelectedCell] = useState({ column: "", value: "" });

   useEffect(() => {
      // hier später die Daten laden
   }, []);

   async function getData(tableName, limit) {
      console.log(tableName);
      console.log(limit);

      await api.post("/api/ip/logs", { tableName, limit }, header).then((data) => {
         console.log(data);
         setLogData(data?.data);
      });
   }

   const handleLimit = (e) => {
      const wert = e.target.value;
      if (wert === "") {
         setLimit("");
         return;
      }
      const zahl = parseInt(wert, 10);
      setLimit(Number.isNaN(zahl) ? "" : Math.max(1, zahl));
   };

   const isObject = (v) => v !== null && (typeof v === "object" || typeof v === "function");

   // NEU: Öffnet das Modal mit dem Inhalt der geklickten Zelle
   const handleCellClick = (column, value, row) => {
      console.log(column);

      setSelectedCell({ column, value, row });
      setShowModal(true);
   };

   const handleCloseModal = () => setShowModal(false);

   return (
      <div className="m-5">
         <Form className="mb-3">
            <Row className="g-2">
               <Col xs={12} md={6}>
                  <Form.Group controlId="filterRolle">
                     <Form.Label>Tabelle</Form.Label>
                     <Form.Select value={tableName} onChange={(e) => setTableName(e.target.value)}>
                        {tableNames.map((r) => (
                           <option key={r} value={r}>
                              {r}
                           </option>
                        ))}
                     </Form.Select>
                  </Form.Group>
               </Col>

               <Col xs={12} md={6}>
                  <Form.Group controlId="maxEintraege">
                     <Form.Label>Max. Einträge</Form.Label>
                     <Form.Control
                        type="number"
                        min={1}
                        step={1}
                        inputMode="numeric"
                        value={limit}
                        onChange={handleLimit}
                     />
                  </Form.Group>
               </Col>
            </Row>
            <Button
               className="my-4 w-100"
               onClick={() => {
                  getData(tableName, limit);
               }}
            >
               Laden
            </Button>
         </Form>

         <div style={{ width: "100%", overflow: "auto", maxHeight: "90vh" }}>
            <Table striped bordered hover>
               <thead>
                  <tr>
                     {logData?.columns?.map((item) => {
                        return (
                           <th
                              key={item.key}
                              style={{
                                 position: "sticky",
                                 top: 0,
                                 zIndex: 1,
                                 background: item.editable ? "#fff" : "#ddd",
                              }}
                           >
                              {item.key}
                           </th>
                        );
                     })}
                  </tr>
               </thead>
               <tbody>
                  {logData?.rows?.map((row) => (
                     <tr key={row.id}>
                        {Object.entries(row).map(([column, item], index) => {
                           let columnData = logData?.columns?.find((item) => item.key === column);
                           let parsedItem = isObject(item) ? JSON.stringify(item, null, 4) : item;
                           if (typeof parsedItem === "boolean") {
                              parsedItem = parsedItem ? "true" : "false";
                           }

                           return (
                              <td
                                 key={index}
                                 style={{ minWidth: "200px", cursor: "pointer" }}
                                 onClick={() => handleCellClick(columnData, parsedItem, row)}
                              >
                                 <div
                                    style={{
                                       maxWidth: "60vw",
                                       whiteSpace: "pre-wrap",
                                       wordBreak: "break-word",
                                       fontFamily: "monospace",
                                       fontSize: "0.85em",
                                       maxHeight: "200px",
                                       overflowY: "auto",
                                    }}
                                 >
                                    {parsedItem}
                                 </div>
                              </td>
                           );
                        })}
                     </tr>
                  ))}
               </tbody>
            </Table>
         </div>

         {/* NEU: Modal für die Detailansicht einer Zelle */}
         <Modal show={showModal} onHide={handleCloseModal} size="xl" centered scrollable>
            <Modal.Header closeButton>
               <Modal.Title>{selectedCell.key}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               {selectedCell?.column?.editable ? (
                  <Form>
                     <Form.Group className="mb-3" key="abc">
                        <Form.Control
                           as="textarea"
                           placeholder=""
                           onChange={(e) => setSelectedCell((prev) => ({ ...prev, value: e.target.value }))}
                           value={selectedCell.value}
                           style={{ min: "300px", fieldSizing: "content" }}
                        />
                     </Form.Group>
                     <Button
                        onClick={() => {
                           console.log(selectedCell.row);
                           try {
                              let parsedValue = selectedCell.value;
                              if (selectedCell.column.type === "JSONB") {
                                 parsedValue = JSON.parse(selectedCell.value);
                              }

                              saveData(tableName, tableIds[tableName], selectedCell.row[tableIds[tableName]], {
                                 [selectedCell.column.key]: parsedValue,
                              });
                           } catch (error) {
                              window.alert(error);
                           }
                           // saveData(table, idName, id, data);
                        }}
                     >
                        Speichern
                     </Button>
                  </Form>
               ) : (
                  <div
                     style={{
                        padding: 10,
                        background: "#ddd",
                     }}
                  >
                     <pre
                        style={{
                           whiteSpace: "pre-wrap",
                           wordBreak: "break-word",
                           fontFamily: "monospace",
                           fontSize: "0.9em",
                           margin: 0,
                        }}
                     >
                        {selectedCell.value}
                     </pre>
                  </div>
               )}
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={handleCloseModal}>
                  Schließen
               </Button>
            </Modal.Footer>
         </Modal>
      </div>
   );
}
